class Sticky {
	constructor() {
		this.init();
	}
	init() {
		this.$negativeSpaces = document.querySelectorAll('.component-sticky--negative-space');

		this.$negativeSpaces.forEach((el) => {
			document.querySelector(
				'.component-sticky--gets-negative-space-' + el.dataset.scrollid
			).style.marginTop = '-' + el.offsetHeight + 'px';
		});

		this.$stickyComponents = document.querySelectorAll('.component-sticky__sticky');

		this.stickyComponentAttributes = [];

		this.$stickyComponents.forEach((el, i) => {
			this.stickyComponentAttributes[i] = {};
			this.stickyComponentAttributes[i].el = el;
			const borderBottomWidth = getComputedStyle(el.closest('.component-sticky'))
				.getPropertyValue('border-bottom-width')
				.match(/\d+/);
			if (borderBottomWidth[0] && parseInt(borderBottomWidth[0])) {
				this.stickyComponentAttributes[i].navHeight =
					el.offsetHeight + parseInt(borderBottomWidth[0]) + 1;
			} else {
				this.stickyComponentAttributes[i].navHeight = el.offsetHeight;
			}
			this.stickyComponentAttributes[i].anchorLinks = el.closest('.component-sticky').dataset
				.linkClass
				? el.querySelectorAll('.' + el.closest('.component-sticky').dataset.linkClass)
				: [];
			this.stickyComponentAttributes[i].targetPositions = [];
			this.stickyComponentAttributes[i].stickTop = this.getCoords(
				el.closest('.component-sticky')
			).top;
			const stopTargets = el
				.closest('.component-sticky')
				.dataset.stop.split(',')
				.map((element) => {
					return element.trim();
				});
			const stopPositions = [];
			stopTargets.forEach((el2) => {
				document.querySelectorAll(el2).forEach((el3) => {
					stopPositions.push(this.getCoords(el3).top);
				});
			});
			let logicalStop = 0;
			stopPositions.sort(function (a, b) {
				return a - b;
			});
			stopPositions.forEach((el2) => {
				if (0 === logicalStop && el2 > this.stickyComponentAttributes[i].stickTop) {
					logicalStop = el2;
				}
			});
			this.stickyComponentAttributes[i].stickBottom = logicalStop;
			this.stickyComponentAttributes[i].linkActiveClass =
				el.closest('.component-sticky').dataset.linkActiveClass;

			el.closest('.component-sticky').style.height =
				this.stickyComponentAttributes[i].navHeight + 'px';
		});
	}
	changeStickyClasses() {
		this.stickyComponentAttributes.forEach((item) => {
			if (
				window.scrollY >= item.stickTop &&
				window.scrollY + item.navHeight <= item.stickBottom
			) {
				item.el.classList.remove('component-sticky__sticky--relative');
				item.el.classList.remove('component-sticky__sticky--absolute');
				item.el.classList.add('component-sticky__sticky--fixed');
				item.el.style.top = 0;
			} else {
				item.el.classList.remove('component-sticky__sticky--fixed');
				if (window.scrollY < item.stickTop) {
					item.el.classList.add('component-sticky__sticky--relative');
					item.el.style.top = 'auto';
				} else {
					item.el.classList.add('component-sticky__sticky--absolute');
					item.el.style.top =
						item.stickBottom -
						this.getCoords(item.el.offsetParent).top -
						item.navHeight +
						'px';
				}
			}
		});
	}
	getCoords(elem) {
		if (elem) {
			const box = elem.getBoundingClientRect();

			const body = document.body;
			const docEl = document.documentElement;

			const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
			const scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

			const clientTop = docEl.clientTop || body.clientTop || 0;
			const clientLeft = docEl.clientLeft || body.clientLeft || 0;

			const top = box.top + scrollTop - clientTop;
			const left = box.left + scrollLeft - clientLeft;

			return { top: Math.round(top), left: Math.round(left) };
		}
	}
}

const newSticky = new Sticky();

const controller = {
	init() {
		newSticky.changeStickyClasses();
	},
	loaded() {
		newSticky.changeStickyClasses();
	},
	resized() {
		newSticky.changeStickyClasses();
	},
	scrolled() {
		newSticky.changeStickyClasses();
	},
	pageHeightChange() {
		newSticky.init();
		newSticky.changeStickyClasses();
	},
};

controller.init();

window.addEventListener('load', controller.loaded);
window.addEventListener('scroll', controller.scrolled, {
	passive: true,
});
window.addEventListener('resize', controller.resized);
window.addEventListener('pageHeightChange', controller.pageHeightChange);
